import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import Routes from 'routing/Routes';

import styles from './LicenseNotification.css';

const LicenseExpirationWarningNotification = React.createClass({
  propTypes: {
    expiresIn: PropTypes.string.isRequired,
    onReminderClick: PropTypes.func.isRequired,
    enableReminderButton: PropTypes.bool,
  },

  getDefaultProps() {
    return {
      enableReminderButton: true,
    };
  },

  render() {
    return (
      <div className={`container-fluid ${styles.licenseNotification}`}>
        <Alert bsStyle="warning">
          <p>
            <strong>Graylog Enterprise License Expiration Warning:</strong>
            &nbsp;
            Your Graylog Enterprise license will expire in <strong>{this.props.expiresIn}</strong>.
            Go to the <LinkContainer to={Routes.pluginRoute('SYSTEM_LICENSES')}><a>License page</a></LinkContainer> for
            more information or contact your Graylog account manager.
            {this.props.enableReminderButton &&
            <Button bsSize="xsmall" className="pull-right" onClick={this.props.onReminderClick}>
              <i className="fa fa-times" /> Remind me later
            </Button>
            }
          </p>
        </Alert>
      </div>
    );
  },
});

export default LicenseExpirationWarningNotification;



// WEBPACK FOOTER //
// ./src/web/notifications/LicenseExpirationWarningNotification.jsx